'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var recommendedFareTooltipTemplate = _.template(require('../templates/fare-tooltip.html'));
var fbcTemplate = _.template(require('../templates/fbc-tooltip.html'));
var recommendedFareTooltipTemplateWithSharedFbc = _.template(require('../templates/fare-tooltip-shared-fbc.html'));
var fbcToolTipTemplate = _.template(require('../templates/tactical-fbc-tooltip.html'));
var entryLevelFbcToolTipTemplate = _.template(require('../templates/tactical-entry-level-fbc-tooltip.html'));
var fareBrandDescriptionToolTipTemplate = _.template(require('../templates/fare-brand-description-tooltip.html'));
var normalizedTotalFareToolTipTemplate = _.template(require('../templates/normalized-total-fare-tooltip.html'));
var webFareToolTipTemplate = _.template(require('../templates/web-fare-tooltip.html'));
var recommendationStatusToolTipTemplate = _.template(require('../templates/recommendation-status-tooltip.html'));
var testTemplate = _.template(require('../templates/fare-fbc-adaptive-tooltip.html'));
var FaresOptimizerFareTooltipService = function FaresOptimizerFareTooltipService(momentService, $filter, faresOptimizerConstants, faresOptimizerDataTransformerService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var TOOLTIP_FIELDS = [{
    label: 'YQ',
    fieldName: 'yq'
  }, {
    label: 'YR',
    fieldName: 'yr'
  }, {
    label: '6H',
    fieldName: 'sixH'
  }, {
    label: '6I',
    fieldName: 'sixI'
  }, {
    label: '6J',
    fieldName: 'sixJ'
  }, {
    label: '6K',
    fieldName: 'sixK'
  }, {
    label: 'Airport Tax',
    fieldName: 'airportTax'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'q'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'qMisc'
  }];
  var ADAPTIVE_EFFECTIVE_TOOLTIP_FIELDS = [{
    label: 'YQ',
    fieldName: 'yq'
  }, {
    label: 'YR',
    fieldName: 'yr'
  }, {
    label: 'Airport Tax',
    fieldName: 'other'
  }, {
    label: 'Variable Tax',
    fieldName: 'variable'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'q'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'qmisc'
  }];
  var ADAPTIVE_CURRENT_FARE_TOOLTIP_FIELDS = [{
    label: 'YQ',
    fieldName: 'currentFareYq'
  }, {
    label: 'YR',
    fieldName: 'currentFareYr'
  }, {
    label: 'Airport Tax',
    fieldName: 'currentFareOther'
  }, {
    label: 'Variable Tax',
    fieldName: 'currentFareVariable'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'currentFareQ'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'currentFareQmisc'
  }];
  var ADAPTIVE_OFFER_PRICE_TOOLTIP_FIELDS = [{
    label: 'YQ',
    fieldName: 'offerYq'
  }, {
    label: 'YR',
    fieldName: 'offerYr'
  }, {
    label: 'Airport Tax',
    fieldName: 'offerOther'
  }, {
    label: 'Variable Tax',
    fieldName: 'offerVariable'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'offerQ'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'offerQmisc'
  }];
  var COMPETITOR_TOOLTIP_FIELDS = [{
    label: 'Base Fare',
    fieldName: 'compBaseFare'
  }, {
    label: 'YQ',
    fieldName: 'compYq'
  }, {
    label: 'YR',
    fieldName: 'compYr'
  }, {
    label: '6H',
    fieldName: 'compSixH'
  }, {
    label: '6I',
    fieldName: 'compSixI'
  }, {
    label: '6J',
    fieldName: 'compSixJ'
  }, {
    label: '6K',
    fieldName: 'compSixK'
  }, {
    label: 'Airport Tax',
    fieldName: 'compAirportTax'
  }, {
    label: 'Variable Tax',
    fieldName: 'compVariable'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'compQ'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'compQMisc'
  }];
  var COMPETITOR_FIELDS = {
    'BASE FARE': 'compBaseFare',
    'YQ': 'compYq',
    'YR': 'compYr',
    '6H': 'compSixH',
    '6I': 'compSixI',
    '6J': 'compSixJ',
    '6K': 'compSixK',
    'FUEL SURCHARGE': 'compQ',
    'OTHER': 'compAirportTax',
    'VARIABLE': 'compVariable',
    'CAT12 SURCHARGE': 'compQMisc'
  };
  var EFFECIVE_FIELDS = {
    'BASE FARE': 'effectiveBaseFare',
    'YQ': 'yq',
    'YR': 'yr',
    '6H': 'sixH',
    '6I': 'sixI',
    '6J': 'sixJ',
    '6K': 'sixK',
    'FUEL SURCHARGE': 'q',
    'OTHER': 'airportTax',
    'VARIABLE': 'effectiveVariable',
    'CAT12 SURCHARGE': 'qMisc'
  };
  var WEB_FIELDS = {
    'BASE FARE': 'baseFare',
    'YQ': 'yq',
    'YR': 'yr',
    '6H': 'sixH',
    '6I': 'sixI',
    '6J': 'sixJ',
    '6K': 'sixK',
    'FUEL SURCHARGE': 'q',
    'OTHER': 'airportTax',
    'VARIABLE': 'variable',
    'CAT12 SURCHARGE': 'qMisc'
  };
  var DEFAULT_FIELDS = {
    'BASE FARE': 'recommendedFareBase',
    'YQ': 'yq',
    'YR': 'yr',
    '6H': 'sixH',
    '6I': 'sixI',
    '6J': 'sixJ',
    '6K': 'sixK',
    'FUEL SURCHARGE': 'q',
    'OTHER': 'airportTax',
    'VARIABLE': 'recommendedVariable',
    'CAT12 SURCHARGE': 'qMisc'
  };
  var DEFAULT_BENCHMARK_FARE_COMPONENT = 'BASE FARE,YQ,YR,6H,6I,6J,6K,FUEL SURCHARGE,OTHER,VARIABLE,CAT12 SURCHARGE';
  var getFareComponents = function getFareComponents(row, type) {
    var TOOLTIP_FIELDS_1 = TOOLTIP_FIELDS.slice();
    var benchmarkFareComponentFieldNames = getBenchmarkFareComponentFieldNames(row, type);
    switch (type) {
      case 'effective':
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'effectiveBaseFare'
        });
        TOOLTIP_FIELDS_1.splice(8, 0, {
          label: 'Variable Tax',
          fieldName: 'effectiveVariable'
        });
        break;
      case 'displayComp':
        TOOLTIP_FIELDS_1 = COMPETITOR_TOOLTIP_FIELDS.slice();
        break;
      case 'webfare':
        TOOLTIP_FIELDS_1.splice(3, 2);
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'baseFare'
        });
        TOOLTIP_FIELDS_1.splice(8, 0, {
          label: 'Variable Tax',
          fieldName: 'variable'
        });
        break;
      case 'ADAPTIVE_EFFECTIVE':
        TOOLTIP_FIELDS_1 = ADAPTIVE_EFFECTIVE_TOOLTIP_FIELDS.slice();
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'effectiveBaseFare'
        });
        break;
      case 'ADAPTIVE_CURRENT':
        TOOLTIP_FIELDS_1 = ADAPTIVE_CURRENT_FARE_TOOLTIP_FIELDS.slice();
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'currentFareBase'
        });
        break;
      case 'ADAPTIVE_GDS':
        TOOLTIP_FIELDS_1 = ADAPTIVE_EFFECTIVE_TOOLTIP_FIELDS.slice();
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'filedFareAmount'
        });
        break;
      case 'ADAPTIVE_OFFER_PRICE':
        TOOLTIP_FIELDS_1 = ADAPTIVE_OFFER_PRICE_TOOLTIP_FIELDS.slice();
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'journeyAmount'
        });
        break;
      default:
        TOOLTIP_FIELDS_1.splice(0, 0, {
          label: 'Base Fare',
          fieldName: 'recommendedFareBase'
        });
        TOOLTIP_FIELDS_1.splice(8, 0, {
          label: 'Variable Tax',
          fieldName: 'recommendedVariable'
        });
    }
    return getMappedToolTipFields(TOOLTIP_FIELDS_1, benchmarkFareComponentFieldNames, row);
  };
  function getMappedToolTipFields(tooltipFields, benchmarkFareComponentFieldNames, row) {
    return _.map(tooltipFields, function (tooltipField) {
      return {
        included: benchmarkFareComponentFieldNames.indexOf(tooltipField.fieldName) > -1,
        label: tooltipField.label,
        value: rmNumberFormat(row[tooltipField.fieldName], 'NUMBER_NO_DECIMAL')
      };
    });
  }
  function getTooltipData(row, type) {
    return {
      fbc: row.fbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareBrand: getFareBrandForToolTip(row.fareBrand),
      fareComponents: getFareComponents(row, type),
      fareTotal: rmNumberFormat(row[type === 'ADAPTIVE_CURRENT' ? 'currentTotalFare' : type === 'ADAPTIVE_GDS' ? 'filedTotalFareAmount' : 'effectiveTotalFare'], 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: true
    };
  }
  function getRecommendedFareTooltipData(row) {
    return {
      fbc: row.fbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareBrand: getFareBrandForToolTip(row.fareBrand),
      fareComponents: getFareComponents(row, 'recommended'),
      fareTotal: rmNumberFormat(row.recommendedFareTotal, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: true
    };
  }
  function getEffectiveFareTooltipData(row) {
    return getTooltipData(row, 'effective');
  }
  function getEffectiveFareAdaptiveTooltipData(row) {
    return getTooltipData(row, 'ADAPTIVE_EFFECTIVE');
  }
  function getCurrentFareAdaptiveTooltipData(row) {
    return getTooltipData(row, 'ADAPTIVE_CURRENT');
  }
  function getGDSFareAdaptiveTooltipData(row) {
    return getTooltipData(row, 'ADAPTIVE_GDS');
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : momentService.of(date, momentService.TYPE.LOCAL_DATE);
  }
  function getSeasonDates(row) {
    var season = row.journeyTypeCd === 'OB' ? 'OutboundSeason' : 'InboundSeason';
    var dateTooltipDetails = row.seasons.map(function (item, index) {
      return {
        label: season + (index + 1),
        begin: rmMomentFormat(getMomentType(item.begin), momentService.DATE_USER_SETTINGS),
        end: rmMomentFormat(getMomentType(item.end), momentService.DATE_USER_SETTINGS)
      };
    });
    return {
      inboundSeason: row.journeyTypeCd === 'IB' ? dateTooltipDetails : [],
      outboundSeason: row.journeyTypeCd === 'OB' ? dateTooltipDetails : []
    };
  }
  function getBlackoutDates(row) {
    var blackout = row.journeyTypeCd === 'OB' ? 'InboundBlackout' : 'OutboundBlackout';
    var date = {
      begin: '01/01',
      end: '31/12'
    };
    var dateTooltipDetails = [{
      label: blackout + 1,
      begin: date.begin,
      end: date.end
    }];
    return {
      inboundBlackout: row.journeyTypeCd === 'OB' ? dateTooltipDetails : [],
      outboundBlackout: row.journeyTypeCd === 'IB' ? dateTooltipDetails : []
    };
  }
  function getFbcAdaptiveTooltipData(row, fbc) {
    return {
      fbc: fbc,
      seasons: getSeasonDates(row),
      blackouts: getBlackoutDates(row)
    };
  }
  function getJourneyFareAdaptiveTooltipData(row) {
    return {
      fbc: row.fbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareBrand: getFareBrandForToolTip(row.fareBrand),
      fareComponents: getFareComponents(row, 'ADAPTIVE_OFFER_PRICE'),
      fareTotal: rmNumberFormat(row.journeyTotalFareAmount, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: true
    };
  }
  function getFbcTooltipData(row) {
    return {
      fareBasisCode: row.fareBasisCode
    };
  }
  function getCompetitorFareTooltipData(row) {
    return {
      fbc: row.compMarketFbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareComponents: getFareComponents(row, 'displayComp'),
      fareTotal: rmNumberFormat(row.compFare, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: false
    };
  }
  function getWebFareTooltipData(row) {
    return {
      fareComponents: getFareComponents(row, 'webfare'),
      fareTotal: rmNumberFormat(row.totalFare, 'NUMBER_NO_DECIMAL')
    };
  }
  function getWebFareTooltipContent(tooltipData) {
    return webFareToolTipTemplate(tooltipData);
  }
  function getFareBrandForToolTip(fareBrand) {
    if (_.isNil(fareBrand) || fareBrand === faresOptimizerConstants.EN_DASH) {
      return '';
    }
    return fareBrand.fareBrand.bold() + ' : ' + fareBrand.description;
  }
  function getFareBrandDescriptionToolTipData(row, isHost) {
    var fareBrand = isHost ? row.fareBrand : row.compFareBrand;
    return {
      title: 'Fare Brand Description',
      description: getFareBrandDescription(fareBrand)
    };
  }
  function getFareBrandDescription(fareBrand) {
    if (_.isNil(fareBrand)) {
      return undefined;
    }
    return fareBrand.description;
  }
  function renderFareBrandDescriptionToolTip(tooltipData) {
    return fareBrandDescriptionToolTipTemplate(tooltipData);
  }
  function getHostFareBrandDescriptionContent(row) {
    var tooltipData = getFareBrandDescriptionToolTipData(row, true);
    return renderFareBrandDescriptionToolTip(tooltipData);
  }
  function getCompFareBrandDescriptionContent(row) {
    var tooltipData = getFareBrandDescriptionToolTipData(row, false);
    return renderFareBrandDescriptionToolTip(tooltipData);
  }
  function shouldRenderHostFareBrandDescriptionToolTip(row) {
    return !(_.isNil(row.fareBrand) || _.isNil(row.fareBrand.description));
  }
  function shouldRenderCompFareBrandDescriptionToolTip(row) {
    return !(_.isNil(row.compFareBrand) || _.isNil(row.compFareBrand.description));
  }
  function shouldRenderNormalizedTotalFareTooltip(row) {
    return !row.isCompetitor;
  }
  function getNormalizedTotalFareTooltipData(row) {
    return {
      label: 'Normalized',
      value: rmNumberFormat(row.normalizedTotalFare, 'NUMBER_NO_DECIMAL')
    };
  }
  function renderNormalizedTotalFareTooltip(tooltipData) {
    return normalizedTotalFareToolTipTemplate(tooltipData);
  }
  function getNormalizedTotalFareTooltipContent(row) {
    var tooltipData = getNormalizedTotalFareTooltipData(row);
    return renderNormalizedTotalFareTooltip(tooltipData);
  }
  var getBenchmarkFareComponentFieldNames = function getBenchmarkFareComponentFieldNames(row, type) {
    var defaultBenchmarkFareComponentArray = DEFAULT_BENCHMARK_FARE_COMPONENT.split(',');
    var benchmarkFareComponentArray = getBenchmarkFareComponent(row).split(',');
    var benchmarkFareComponents = [];
    _.forEach(defaultBenchmarkFareComponentArray, function (component) {
      if (type === 'displayComp') {
        if (benchmarkFareComponentArray.includes(component)) {
          benchmarkFareComponents.push(COMPETITOR_FIELDS[component]);
        }
      } else if (type === 'effective') {
        if (benchmarkFareComponentArray.includes(component)) {
          benchmarkFareComponents.push(EFFECIVE_FIELDS[component]);
        }
      } else if (type === 'webfare') {
        if (benchmarkFareComponentArray.includes(component)) {
          benchmarkFareComponents.push(WEB_FIELDS[component]);
        }
      } else {
        if (benchmarkFareComponentArray.includes(component)) {
          benchmarkFareComponents.push(DEFAULT_FIELDS[component]);
        }
      }
    });
    return benchmarkFareComponents;
  };
  var getBenchmarkFareComponent = function getBenchmarkFareComponent(row) {
    return !_.isNil(row.benchmarkFareComponent) ? row.benchmarkFareComponent : DEFAULT_BENCHMARK_FARE_COMPONENT;
  };
  function getRecommendedFareTooltipContent(row) {
    var tooltipData = getRecommendedFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getFbcTooltipContent(row) {
    var tooltipData = getFbcTooltipData(row);
    return renderFbcTooltip(tooltipData);
  }
  function getEffectiveFareTooltipContent(row) {
    var tooltipData = getEffectiveFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getEffectiveFareAdaptiveTooltipContent(row) {
    var tooltipData = getEffectiveFareAdaptiveTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getCurrentFareAdaptiveTooltipContent(row) {
    var tooltipData = getCurrentFareAdaptiveTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getGDSFareAdaptiveTooltipContent(row) {
    var tooltipData = getGDSFareAdaptiveTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getFbcAdaptiveTooltipContent(row) {
    var tooltipData = getFbcAdaptiveTooltipData(row, row.fbc);
    return renderAdaptiveFbcTooltip(tooltipData);
  }
  function getEntryLevelFbcAdaptiveTooltipContent(row) {
    var tooltipData = getFbcAdaptiveTooltipData(row, extractFbcPattern(row.fbc));
    return renderAdaptiveFbcTooltip(tooltipData);
  }
  function getJourneyTotalFareAdaptiveTooltipContent(row) {
    var tooltipData = getJourneyFareAdaptiveTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getCompetitorFareTooltipContent(row) {
    var tooltipData = getCompetitorFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function renderFbcTooltip(tooltipData) {
    return fbcTemplate(tooltipData);
  }
  function renderFareTooltip(tooltipData) {
    return recommendedFareTooltipTemplate(tooltipData);
  }
  function renderAdaptiveFbcTooltip(tooltipData) {
    return testTemplate(tooltipData);
  }
  function renderFareTooltipWithSharedFbc(tooltipData) {
    return recommendedFareTooltipTemplateWithSharedFbc(tooltipData);
  }
  function extractFbcPattern(fbc) {
    return fbc && fbc.length > 0 ? '*' + fbc.substring(1) : '';
  }
  function getStrategyText(businessRule) {
    var strategyText = businessRule.strategy === 'UNDERCUT' ? businessRule.strategy + ' -' + businessRule.amount : businessRule.strategy + ' +' + businessRule.amount;
    if (businessRule.percentageIndicator) {
      strategyText = strategyText + '%';
    }
    return strategyText;
  }
  function getBusinessRuleData(businessRule) {
    var businessRuleTooltip = ' / ';
    if (businessRule.strategy === 'MATCH') {
      return businessRuleTooltip + businessRule.strategy;
    } else {
      return businessRuleTooltip + getStrategyText(businessRule);
    }
  }
  function getBusinessRuleInfo(row) {
    return !_.isEmpty(row.businessRule) ? getBusinessRuleData(row.businessRule) : '';
  }
  function getFbcHeader(row) {
    var fbcHeader = row.fbc;
    fbcHeader = fbcHeader + getBusinessRuleInfo(row);
    return fbcHeader;
  }
  function getEntryLevelFbcHeader(row) {
    if (isEntryLevelRbdMethod(row)) {
      return extractFbcPattern(row.fbc) + getBusinessRuleInfo(row);
    }
    return getHeaderForNonEntryLevelRbdMethod(row);
  }
  function isEntryLevelRbdMethod(row) {
    return _.isEmpty(row.rbdMethod) || faresOptimizerConstants.RBD_METHOD.ENTRY_LEVEL_RBD === row.rbdMethod;
  }
  function getHeaderForNonEntryLevelRbdMethod(row) {
    if (_.isEmpty(row.businessRule)) {
      return extractFbcPattern(row.fbc);
    }
    return row.fbc + getBusinessRuleInfo(row);
  }
  function getFbcLevelToolTipData(row) {
    var fbcPatternList = _.map(row.sharedEntryLevelFbcList, extractFbcPattern);
    return {
      fbcHeader: getFbcHeader(row),
      ladderList: fbcPatternList,
      actionCode: row.actionCode,
      category: row.category,
      isSharedFbc: row.isSharedFbc,
      isFareChange: row.fareChangeAbsolute,
      isFootnoteUpdated: row.isFootnoteUpdated,
      isRuleUpdated: row.isRuleUpdated,
      effectiveDate: rmMomentFormat(row.effectiveDate, 'DATE_USER_SETTINGS'),
      discontinueDate: rmMomentFormat(row.discontinueDate, 'DATE_USER_SETTINGS'),
      recommendationReasons: getRecommendationReasons(row.ladderRemarks)
    };
  }
  function getEntryLevelFbcToolTipData(row) {
    var fbcPatternList = _.map(row.allSharedEntryLevelFbcList, extractFbcPattern);
    return {
      fbcHeader: getEntryLevelFbcHeader(row),
      ladderList: fbcPatternList,
      actionCode: row.actionCode,
      isSharedFbc: row.isSharedFbc || row.hasSharedFbc,
      isFareChange: row.fareChangeAbsolute,
      isFootnoteUpdated: row.isFootnoteUpdated,
      isRuleUpdated: row.isRuleUpdated,
      effectiveDate: rmMomentFormat(row.effectiveDate, 'DATE_USER_SETTINGS'),
      discontinueDate: rmMomentFormat(row.discontinueDate, 'DATE_USER_SETTINGS'),
      recommendationReasons: getRecommendationReasons(row.ladderRemarks)
    };
  }
  var getFbcToolTip = function getFbcToolTip(row) {
    var toolTipData = getFbcLevelToolTipData(row);
    return renderFbcToolTip(toolTipData);
  };
  var getEntryLevelFbcToolTip = function getEntryLevelFbcToolTip(row) {
    var toolTipData = getEntryLevelFbcToolTipData(row);
    return renderEntryLevelFbcToolTip(toolTipData);
  };
  var getRecommendationReasons = function getRecommendationReasons(ladderRemarks) {
    var recommendationReasons = [];
    if (!_.isUndefined(ladderRemarks) && !_.isUndefined(ladderRemarks.recommendationReasons)) {
      _.forEach(ladderRemarks.recommendationReasons, function (value, key) {
        recommendationReasons.push(_.replace(key, /_/g, ' '));
      });
    }
    return recommendationReasons;
  };
  var renderFbcToolTip = function renderFbcToolTip(toolTipData) {
    return fbcToolTipTemplate(toolTipData);
  };
  var renderEntryLevelFbcToolTip = function renderEntryLevelFbcToolTip(toolTipData) {
    return entryLevelFbcToolTipTemplate(toolTipData);
  };
  var shouldRenderFbcToolTip = function shouldRenderFbcToolTip(row, isGrouped) {
    if (_.includes(['N', 'X', 'C'], row.actionCode) || isGrouped) {
      return true;
    }
    return row.isEntryLevel || row.isSharedFbc || !_.isEmpty(row.businessRule);
  };
  var shouldRenderCompFareToolTip = function shouldRenderCompFareToolTip(row) {
    return !_.isNil(row) && !_.isNil(row.compMarketFbc);
  };
  var getRecommendedFareTooltipDataWithFbc = function getRecommendedFareTooltipDataWithFbc(row) {
    return _.merge({
      isSharedFbc: row.isSharedFbc,
      hasLinkedFbc: row.hasLinkedFbc,
      linkedFbcs: row.linkedFbcs,
      actionCode: row.actionCode,
      category: row.category
    }, getRecommendedFareTooltipData(row), getFbcLevelToolTipData(row));
  };
  var getEffectiveFareTooltipDataWithFbc = function getEffectiveFareTooltipDataWithFbc(row) {
    return _.merge({
      isSharedFbc: row.isSharedFbc,
      hasLinkedFbc: row.hasLinkedFbc,
      linkedFbcs: row.linkedFbcs,
      actionCode: row.actionCode,
      category: row.category
    }, getEffectiveFareTooltipData(row), getFbcLevelToolTipData(row));
  };
  var getRecommendationStatusToolTipContent = function getRecommendationStatusToolTipContent(row) {
    var toolTipData = getRecommendationStatusToolTipData(row);
    return renderRecommendationStatusToolTip(toolTipData);
  };
  function getRecommendationStatusToolTipData(row) {
    return {
      isAutoApprovable: row.isAutoApprovable,
      recommendationStopReasons: getAutoApproveableStopReasons(row.ladderRemarks)
    };
  }
  function getAutoApproveableStopReasons(ladderRemarks) {
    var stopReasons = [];
    if (_.isUndefined(ladderRemarks) || _.isUndefined(ladderRemarks.dataComparisonReasons)) {
      return stopReasons;
    }
    var messageThresholdCount = 10;
    var addMoreIndicator = false;
    var dataComparisonReasons = faresOptimizerDataTransformerService.getDataComparisonReasons(ladderRemarks.dataComparisonReasons, true);
    if (messageThresholdCount < dataComparisonReasons.length) {
      addMoreIndicator = true;
    } else {
      messageThresholdCount = dataComparisonReasons.length;
    }
    for (var i = 0; i < messageThresholdCount; i++) {
      stopReasons.push({
        main: dataComparisonReasons[i].header
      });
    }
    if (addMoreIndicator) {
      stopReasons.push({
        main: faresOptimizerConstants.MORE_CONTENT_INDICATOR
      });
    }
    return stopReasons;
  }
  var renderRecommendationStatusToolTip = function renderRecommendationStatusToolTip(toolTipData) {
    return recommendationStatusToolTipTemplate(toolTipData);
  };
  var shouldRenderRecommendationStatusToolTip = function shouldRenderRecommendationStatusToolTip(row) {
    return row.displayStatus === faresOptimizerConstants.NEW && (row.isRecommendationCapped || row.isAutoApprovable === false);
  };
  return {
    getRecommendedFareTooltipContent: getRecommendedFareTooltipContent,
    getRecommendedFareTooltipData: getRecommendedFareTooltipData,
    getCompetitorFareTooltipData: getCompetitorFareTooltipData,
    getEffectiveFareTooltipContent: getEffectiveFareTooltipContent,
    getEffectiveFareAdaptiveTooltipContent: getEffectiveFareAdaptiveTooltipContent,
    getCurrentFareAdaptiveTooltipContent: getCurrentFareAdaptiveTooltipContent,
    getGDSFareAdaptiveTooltipContent: getGDSFareAdaptiveTooltipContent,
    getFbcAdaptiveTooltipContent: getFbcAdaptiveTooltipContent,
    getEntryLevelFbcAdaptiveTooltipContent: getEntryLevelFbcAdaptiveTooltipContent,
    getJourneyTotalFareAdaptiveTooltipContent: getJourneyTotalFareAdaptiveTooltipContent,
    getRecommendedFareTooltipDataWithFbc: getRecommendedFareTooltipDataWithFbc,
    getEffectiveFareTooltipDataWithFbc: getEffectiveFareTooltipDataWithFbc,
    renderFareTooltip: renderFareTooltip,
    getFbcTooltipData: getFbcTooltipData,
    getFbcTooltipContent: getFbcTooltipContent,
    renderFareTooltipWithSharedFbc: renderFareTooltipWithSharedFbc,
    getHostFareBrandDescriptionContent: getHostFareBrandDescriptionContent,
    getCompFareBrandDescriptionContent: getCompFareBrandDescriptionContent,
    shouldRenderHostFareBrandDescriptionToolTip: shouldRenderHostFareBrandDescriptionToolTip,
    shouldRenderCompFareBrandDescriptionToolTip: shouldRenderCompFareBrandDescriptionToolTip,
    getNormalizedTotalFareTooltipContent: getNormalizedTotalFareTooltipContent,
    shouldRenderNormalizedTotalFareTooltip: shouldRenderNormalizedTotalFareTooltip,
    getFbcToolTip: getFbcToolTip,
    getEntryLevelFbcToolTip: getEntryLevelFbcToolTip,
    shouldRenderFbcToolTip: shouldRenderFbcToolTip,
    shouldRenderCompFareToolTip: shouldRenderCompFareToolTip,
    getCompetitorFareTooltipContent: getCompetitorFareTooltipContent,
    getWebFareTooltipData: getWebFareTooltipData,
    getWebFareTooltipContent: getWebFareTooltipContent,
    getRecommendationStatusToolTipContent: getRecommendationStatusToolTipContent,
    shouldRenderRecommendationStatusToolTip: shouldRenderRecommendationStatusToolTip
  };
};
FaresOptimizerFareTooltipService.$inject = ['MomentService', '$filter', 'FaresOptimizerConstants', 'FaresOptimizerDataTransformerService'];
module.exports = FaresOptimizerFareTooltipService;